<mat-card>
  <mat-grid-list class="viewport-height" cols="3">
    <mat-grid-tile class="viewport-height" colspan="2">
      <div #myIdentifier class="viewport-height overflow-auto" style="width: 100%; height: 100%;">
        <mat-grid-list cols="1" [rowHeight]="rowHeight"  (window:resize)="onResize($event)">
          <mat-grid-tile *ngIf="angles[0]">
            <app-image-component
              [angle]="angles[0]"
              [image]="images[0]"
              [dynamicImageSet]="dynamicImageSet"
              [selectedOptions]="selectedNodes"
              [testArea]="testArea"
              [containerWidth]="containerWidth"
            ></app-image-component>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="angles[1]">
            <app-image-component
              [angle]="angles[1]"
              [image]="images[1]"
              [dynamicImageSet]="dynamicImageSet"
              [selectedOptions]="selectedNodes"
              [testArea]="testArea"
              [containerWidth]="containerWidth"
            ></app-image-component>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="angles[2]">
            <app-image-component
              [angle]="angles[2]"
              [image]="images[2]"
              [dynamicImageSet]="dynamicImageSet"
              [selectedOptions]="selectedNodes"
              [testArea]="testArea"
              [containerWidth]="containerWidth"
            ></app-image-component>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="angles[3]">
            <app-image-component
              [angle]="angles[3]"
              [image]="images[3]"
              [dynamicImageSet]="dynamicImageSet"
              [selectedOptions]="selectedNodes"
              [testArea]="testArea"
              [containerWidth]="containerWidth"
            ></app-image-component>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="angles[4]">
            <app-image-component
              [angle]="angles[4]"
              [image]="images[4]"
              [dynamicImageSet]="dynamicImageSet"
              [selectedOptions]="selectedNodes"
              [testArea]="testArea"
              [containerWidth]="containerWidth"
            ></app-image-component>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="angles[5]">
            <app-image-component
              [angle]="angles[5]"
              [image]="images[5]"
              [dynamicImageSet]="dynamicImageSet"
              [selectedOptions]="selectedNodes"
              [testArea]="testArea"
              [containerWidth]="containerWidth"
            ></app-image-component>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-grid-tile>
    <mat-grid-tile class="viewport-height" colspan="1">
      <div fxLayout="column" class="viewport-height viewport-width overflow-auto">
        <mat-label class="grey-font">Target exterior layers: </mat-label
        ><mat-label>{{ target.extLayerSourceDisId }}</mat-label
        ><br />
        <mat-label class="grey-font">Target exterior rules : </mat-label
        ><mat-label>{{ target.extRulesSourceDisId }}</mat-label
        ><br />
        <mat-label class="grey-font">Target interior layers: </mat-label
        ><mat-label>{{ target.intLayerSourceDisId }}</mat-label>
        <br />
        <mat-label class="grey-font">Target interior rules : </mat-label
          ><mat-label>{{ target.intRulesSourceDisId }}</mat-label>
        <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodeToggle
            matTreeNodePadding
            matTreeNodePaddingIndent="30"
          >
            <mat-radio-group aria-multiselectable="false" class="smallRadio">
              <mat-radio-button
                class="checklist-leaf-node"
                [checked]="checklistSelection.isSelected(node)"
                [disabled]="isDisabled(node)"
                (change)="layerSelectionToggle(node)"
                [value]="node.item"
                data-toggle="tooltip"
                data-placement="top"
                title="{{ node.description }}"
              >
                <label>{{ node.item }}</label>
                <span
                  style="font-size: 0.73rem; color: rgba(0, 0, 0, 0.54);"
                  [class.noneNode] = "node.isNone === true"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="{{ node.description }}"
                >
                  {{ node.description | slice: 0:80 }}
                  <label
                    *ngIf="node.description && node.description.length > 80"
                    >...</label
                  >
                </span></mat-radio-button
              >
            </mat-radio-group>
          </mat-tree-node>

          <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
          >
            <button
              mat-icon-button
              matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.item"
            >
              <mat-icon class="mat-icon-rtl-mirror">
                {{
                  treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
                }}
              </mat-icon>
            </button>
            <mat-card-title-group>{{ node.item }}</mat-card-title-group>
          </mat-tree-node>
        </mat-tree>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</mat-card>
